module.exports = __webpack_public_path__ + "img/scoreActive_03.4703840a.svg";